import { Button, Card, CardContent, CardHeader, Container, Divider, Grid, InputAdornment, Paper, TextField, Typography } from "@mui/material";
import { Box } from "@mui/system";
import React from "react";
import Fetch from "../api/Fetch";
import { BACKEND_URI } from "../constants";
import Toaster from "../common/Toaster";
import NoteAddIcon from "@mui/icons-material/NoteAdd";
import TitleIcon from "@mui/icons-material/Title";
import MessageIcon from "@mui/icons-material/Message";
import SendIcon from "@mui/icons-material/Send";

const NoteView = () => {
    const [loading, setLoading] = React.useState<boolean>(false);
    const [request, setRequest] = React.useState({ title: "", message: "" });

    const onSubmit = async (e: any) => {
        e.preventDefault();
        if (!request.title || !request.message) {
            Toaster.error("Must fill out both fields before sending.");
            return;
        }
        setLoading(true);
        try {
            await Fetch(`${BACKEND_URI}/notes`, {
                method: "POST",
                includeAuth: true,
                body: request,
                isText: true,
            });
            setRequest({ title: "", message: "" });
            Toaster.success("Note sent successfully.");
        } catch (err: any) {
            console.log(err);
            Toaster.error(err.message ?? "An error occurred while sending note.");
        } finally {
            setLoading(false);
        }
    };

    return (
        <Container maxWidth="md" sx={{ py: 3 }}>
            <Typography variant="h4" sx={{ mb: 3, fontWeight: 500 }}>
                Notes
            </Typography>
            <Paper elevation={2} sx={{ borderRadius: 2 }}>
                <CardHeader
                    title="Create Note"
                    subheader="Send a note to the management team"
                    titleTypographyProps={{ variant: "h6" }}
                    avatar={<NoteAddIcon />}
                    sx={{
                        backgroundColor: "primary.main",
                        color: "text.primary",
                    }}
                />
                <Divider />
                <CardContent sx={{ p: 3 }}>
                    <Box component="form" onSubmit={onSubmit}>
                        <Grid container spacing={3}>
                            <Grid item xs={12}>
                                <TextField
                                    fullWidth
                                    label="Title"
                                    variant="outlined"
                                    disabled={loading}
                                    value={request.title}
                                    onChange={(e) => setRequest({ ...request, title: e.target.value })}
                                    InputProps={{
                                        startAdornment: (
                                            <InputAdornment position="start">
                                                <TitleIcon color="action" />
                                            </InputAdornment>
                                        ),
                                    }}
                                    required
                                    placeholder="Enter a descriptive title for your note"
                                />
                            </Grid>
                            <Grid item xs={12}>
                                <TextField
                                    fullWidth
                                    label="Message"
                                    variant="outlined"
                                    multiline
                                    minRows={8}
                                    disabled={loading}
                                    value={request.message}
                                    onChange={(e) => setRequest({ ...request, message: e.target.value })}
                                    InputProps={{
                                        startAdornment: (
                                            <InputAdornment position="start" sx={{ alignSelf: "flex-start", mt: 2 }}>
                                                <MessageIcon color="action" />
                                            </InputAdornment>
                                        ),
                                    }}
                                    required
                                    placeholder="Describe your note in detail..."
                                />
                            </Grid>
                            <Grid item xs={12} sx={{ textAlign: "right" }}>
                                <Button
                                    variant="contained"
                                    type="submit"
                                    disabled={loading || !request.title.trim() || !request.message.trim()}
                                    size="large"
                                    startIcon={<SendIcon />}
                                    sx={{
                                        px: 4,
                                        py: 1.5,
                                        borderRadius: 2,
                                        fontSize: "1rem",
                                        fontWeight: 600,
                                    }}
                                >
                                    {loading ? "Sending..." : "Send Note"}
                                </Button>
                            </Grid>
                        </Grid>
                    </Box>
                </CardContent>
            </Paper>
        </Container>
    );
};

export default NoteView;
